import {
  Component,
  ElementRef,
  ViewChild,
  Input,
  AfterViewInit,
  HostListener
} from '@angular/core';

@Component({
  standalone: false,  // this is now required when using NgModule,
  selector: 'app-splitter',
  templateUrl: './splitter.component.html',
  styleUrls: ['./splitter.component.css']
})
export class SplitterComponent implements AfterViewInit {
  @ViewChild('container', { static: true }) container!: ElementRef;

  @Input() direction: 'horizontal' | 'vertical' = 'horizontal';

  @Input() min = 100;
  @Input() max = 1000;
  @Input() initial = 300;

  size!: number;
  private lastSize!: number;
  private dragging = false;

  collapsed = false;

  ngAfterViewInit() {
    this.size = this.initial;
    this.lastSize = this.initial;
  }

  startDrag(event: MouseEvent) {
    if (this.collapsed) {
      this.toggle();
    }

    event.preventDefault();
    this.dragging = true;
  }

@HostListener('document:mousemove', ['$event'])
onMouseMove(e: MouseEvent) {
  if (!this.dragging) return;

  const rect = this.container.nativeElement.getBoundingClientRect();

  let newSize =
    this.direction === 'horizontal'
      ? e.clientX - rect.left
      : e.clientY - rect.top;

  this.size = Math.max(this.min, Math.min(this.max, newSize));
}

@HostListener('document:mouseup')
onMouseUp() {
  this.dragging = false;
}

  toggle() {
    this.collapsed = !this.collapsed;

    if (this.collapsed) {
      this.lastSize = this.size;
      this.size = 0;
    } else {
      this.size = this.lastSize || this.initial;
    }
  }

}